const manifest = {
  ACCTSUMMARY: { name: 'Account Summary', path: 'accountSummaryWidget/AccountSummaryWidget' },
  ACHPASSTHRU: { name: 'ACH Pass-Thru', path: 'achPassThru/ACHPassThru' },
  ACHPOSPAY: { name: 'ACH Positive Pay', path: 'achPosPay/ACHPositivePay' },
  ACHTOTALS: { name: 'ACH Totals', path: 'achTotals/ACHTotalsWidget' },
  ALERT: { name: 'Notifications', path: 'notifications/Notifications' },
  ALERTS: { name: 'Alerts', path: 'alerts/Alerts' },
  AUDITREPORT: { name: 'Audit Report', path: 'auditReport/AuditReportWidget' },
  BLANK: { path: 'blankWidget/BlankWidget' },
  CBEADMIN: { name: 'User Maintenance', path: 'userMaintenance/UserMaintenanceWidget' },
  CDREPORT: {
    name: 'Controlled Disbursement',
    path: 'controlledDisbursementsWidget/ControlledDisbursementsWidget'
  },
  CFF: { name: 'Cash Flow Forecasting', path: 'cashFlowForecasting/CashFlowForecasting' },
  CHCKISSUEMNG: {
    name: 'Check Issue Management',
    path: 'checkIssueManagement/CheckIssueManagement'
  },
  CONTACTCNTR: { name: 'Payee Directory', path: 'contactCenterListView/ContactCenterListView' },
  ERD: { name: 'Electronic Reports', path: 'electronicReports/ElectronicReports' },
  ESTATEMENTSR: { name: 'Statements', path: 'statementSearch/StatementSearch' },
  FINOVERVIEW: { name: 'Financial Overview', path: 'financialOverview/FinancialOverviewWrapper' },
  NOTIFICATIONS: { name: 'Notifications', path: 'notifications/Notifications' },
  NOTIFY: { name: 'Notifications', path: 'notifications/Notifications' },
  POSPAYFC: {
    name: 'Check Positive Pay',
    path: 'paymentFraudControl/PaymentFraudControl'
  },
  PYMTLSTVIEW: { name: 'Payments', path: 'payments/web/Payments' },
  QUICKLINKS: {
    name: 'Quick Links',
    path: 'quickLinks/QuickLinks'
  },
  QUICKTRF: {
    initialValues: { transferTo: '2' },
    name: 'Quick Transfer',
    path: 'quickTransfer/QuickTransfer'
  },
  SMBPYMT: {
    name: 'Simplified Payments',
    path: 'smallBusinessPayments/SmallBusinessWrapper'
  },
  SMRTCHRT: { name: 'Smart Chart', path: 'smartChart/SmartChart' },
  STOPPYMT: { name: 'Stop Payments', path: 'stopPayments/StopPayments' },
  TRANSFERS: { name: 'Transfers', path: 'transfers/Transfers' },
  TRNSFRTEMPLT: { name: 'Transfer Templates', path: 'transferTemplates/TransferTemplates' },
  TXNSEARCH: { name: 'Transaction Search', path: 'transactionSearch/TransactionSearch' }
};

export default manifest;
